module.exports = __webpack_public_path__ + "images/c392e22a9a26228407d2f7ad053ce03e.png";